//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import 'swiper/dist/css/swiper.css'
  import _ from 'lodash'
  import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import { postureSymp} from "../assets/lang.conf/root";
  import 'bootstrap/dist/css/bootstrap.css'
  import 'bootstrap-vue/dist/bootstrap-vue.css'
  import Symp_item from './Symp_item'

export default {
    name: 'Postrue_symp',
    i18n: { // `i18n` option, setup locale info for component
      messages: {
        ...postureSymp
      }

    },
    directive: {
        bModalDirective
    },
    components: {
        Symp_item
    },
    props : [
        'severeRisks',
        'mildRisks',
        'normalRisks',
    ],
    data() {
        return {
            level: {
                normal: 'normal',
                mild: 'mild',
                severe: 'severe'
            },
            tips:{
                riskCount:0,
                riskTip: this.$t('risk')
            },
            isShow:false,
            riskLevelList:[],
            hClass:false,
            mClass:false,
            nClass:false,
            classleve:'normal',
            ntips:{
                tip: this.$t('normal')
            },
            mtips:{
                tip: this.$t('potentialRisk')
            }

        };
    },
    computed: {

    },
    methods: {
        getRiskImg(risk){
            let direction = 'normal';
            let img;
            if(!_.isNull( risk.direction) && risk.key !== 'legO' && risk.key !== 'legX' && risk.key !== 'legXO' && risk.key !== 'kneeOverstretch'){
                direction = risk.direction
            }
            if(this.checkIfAbnormal(risk.level)){
            img = risk.abnormal[direction];
            }else{
            img = risk.normal[direction];
            }
            return img;
        },
        checkIfAbnormal (level) {
            switch (level) {
            case this.level.normal:
                return false
            case this.level.mild:
                return false
            case this.level.severe:
                return true
            }
        },
        share:function(risk){
            this.$emit('share')
        },
        setModalInfo:function(risk){
            this.$emit('setModalInfo',risk)
        },
        getSolutions:function(risk){
            this.$emit('getSolutions',risk)
        }

    },
    created () {
        let riskTips = {},
            riskCount=0,
            riskTip='';

        if( this.severeRisks.length >0 ){
            riskCount = this.severeRisks.length;
            // riskTip='高风险'
            riskTip=this.$t('heightRisk')
            this.isShow=true;
            this.hClass = true;
            riskTips.tip = riskTip
            this.classleve='severe';
            this.riskLevelList = this.severeRisks
          //console.log("this.riskTipsddddddddddddddddd:",this.severeRisks)

        }else if(this.mildRisks.length >0){
            riskCount = this.mildRisks.length;
            // riskTip='潜在风险';
            riskTip=this.$t('potentialRisk');
            this.isShow=false;
            this.mClass = true;
            riskTips.tip = riskTip
            this.classleve='mild';
            this.riskLevelList = this.mildRisks
        }else{
            riskCount = this.normalRisks.length
            // riskTip='风险'
            riskTip=this.$t('risk');
            this.isShow=false;
            this.nClass=true;
        }
        riskTips.riskCount = riskCount;
        riskTips.riskTip = riskTip;
        this.tips = Object.assign({}, riskTips);

    },
    mounted() {
      console.log({
        'severeRisks': this.severeRisks,
        'mildRisks': this.mildRisks,
        'normalRisks': this.normalRisks
      })
    }
}
  


// WEBPACK FOOTER //
// ./src/components/Posture_symp.vue